export const REGISTEREDCHILDRENTHISYEAR_LABELS = {
  counter: {
    en: "Registered Children - This Year",
    ta: "பதிவு செய்யப்பட்ட குழந்தைகள் - இந்த ஆண்டு",
    si: "ලියාපදිංචි දරුවන් - මෙම වසරේ",
  },
};
